import * as React from "react"
import * as _ from "lodash"
import * as $ from "jquery"
import {IPatientVitalHistory, IPatientVitalResponse} from "./../models/IPatientVitalResponse"
import {Chart} from "react-google-charts"
import AppUtils from "../utils/AppUtils";

/**
 * Created by aditya on 26/02/18.
 */

export const vitalToChartColorMapping = [
    { name: "TEMPERATURE", color: "#778dff"},
    { name: "BMI", color: "#778dff"},
    { name: "PULSE RATE", color: "#fcbb24"},
    { name: "SPO2", color: "#e2431e"},
    { name: "RESPIRATORY RATE", color: "#37e3f5"},
    { name: "WEIGHT", color: "#fcbb24"},
    { name: "HEIGHT", color: "#e2431e"},
    { name: "BP", color: "#37e3f5"},
    { name: "WAIST", color: "#778dff"},
    { name: "HIP", color: "#fcbb24"},
    { name: "WHR", color: "#e2431e"},
    { name: "WAIST GIRTH", color: "#789382"},
]

export interface PatientVitalsViewProps {
    currentValue: string;
    averageValue: string;
    rows: any;
    chartName: string;
    rootClass: string;
    subClass: string;
    title: string;
    width?: number;
    height?: number
}


export interface PatientVitalsViewState {

}

export const DefaultChartOptions: any = {
    // curveType: "function",
    pointsVisible: true,
    legend: {position: "none"},
    backgroundColor: "#f1f5f8",
    hAxis: {showTextEvery: 1, baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "grey"}, viewWindow: {max: 12, min: 1, interval: 1}},
    vAxis: {baselineColor: "lightgrey", gridlines: {color: "transparent"}, textStyle: {color: "grey"}},
    tooltip: {isHtml: true},
    interpolateNulls: true
}

const columnDefinition = [{type: "number", role: "domain", label: "Timeline"},
    {type: "number", role: "data", label: "value"},
    {type: "string", role: "tooltip", p: {"html": true}}];

class GoalChartComponent extends React.Component<PatientVitalsViewProps, PatientVitalsViewState> {

    constructor(props: PatientVitalsViewProps) {
        super(props);
    }

    render() {
        let rows = this.props.rows;
        let columnDefs = columnDefinition;
        let chartOptions = { ...DefaultChartOptions };
        let chartColor = { 0: { color: "#9013fe" }, 1: { color: "#19cf34" } };
        chartOptions.series = chartColor;
        return (
            <div className={`${this.props.rootClass} in-blk top-align`}>
                <div className={`${this.props.subClass}-name brandon-bold`}>{this.props.title}</div>
                <div className={`${this.props.subClass}-info-card`}>
                    <div className={`${this.props.subClass}-chart-body expanded`}>
                        <div id={"chart-container"}>
                            <Chart
                                chartType="LineChart"
                                // data={myInstance.generateDataTable(this.props.chartData, this.props.chartName)}
                                rows={rows}
                                columns={columnDefs}
                                options={chartOptions}
                                graph_id={`LineChart-${this.props.chartName}`}
                                width={`${this.props.width || 350}px`}
                                height={`${this.props.height || 200}px`}
                                legend_toggle
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default GoalChartComponent